import { Box, Typography } from '@mui/material'

const InfoText = ({ formField }) => {
  return (
    <Box>
      <Typography
        fontSize={formField?.fontSize ? formField?.fontSize : 'default'}
        variant={formField?.variant ? formField.variant : 'body2'}
      >
        {formField.labels.map(label => (
          <Typography key={label.id || label.text} component="span" sx={{ ...label?.properties }}>
            {label.text}
          </Typography>
        ))}
      </Typography>
    </Box>
  )
}

export default InfoText
